import { useMutation } from '@tanstack/react-query';
import { toast } from '@pella/sash-framework';
import { useAPI } from '@pella/cosmos-react';

/**
 * Hook to create a new move order via the inventory management API.
 * @returns {import('@tanstack/react-query').UseMutationResult} Mutation result with mutateAsync and isPending state.
 */
export const useCreateMoveOrder = () => {
  const { api } = useAPI();

  return useMutation({
    // Bypass _statusCheckedRequest so we get the full response body including
    // outBinds.message — cosmos-core throws before we can read the Oracle error detail.
    // @ts-ignore
    mutationFn: async ({ orgId, body }) => {
      const response = await api.invMgmt._api.post(`organizations/${orgId}/moveorders`, body);
      return response.data;
    },
    onError: (error) => {
      // Only fires on network / HTTP-level failures
      toast.error(`Move order request failed: ${error.message}`);
    },
  });
};
